import { interval, from } from 'rxjs';
import { take, startWith, switchMap, filter } from 'rxjs/operators';
import moment from 'moment';
import Modal from '@roo/roo/Modal';

import request from '@utils/axiosWrapper';
import { getStorage, setStorage } from '@utils/localStorage';

const POLLING_INTERVAL = 5 * 60 * 1000;

/** 隐私号紧急通知 */
const init = () => {
    if (getStorage('wmSendMessageDate') === moment().format('YYYYMMDD')) {
        // 一天只展示1次
        return;
    }

    interval(POLLING_INTERVAL)
        .pipe(
            startWith(null),
            switchMap(() => {
                return from(
                    request
                        .get<{ flag: boolean; message: string }>(
                            '/v2/common/r/privacyPhone/sendMessage',
                        )
                        .then(
                            res => {
                                if (res.flag && res.message && res.message.length > 0) {
                                    return res.message;
                                } else {
                                    return null;
                                }
                            },
                            () => null,
                        ),
                );
            }),
            filter(message => message !== null),
            take(1),
        )
        .subscribe(message => {
            setStorage('wmSendMessageDate', moment().format('YYYYMMDD'));
            Modal.confirm({
                title: '紧急通知',
                children: message,
                showCancelButton: false,
                confirmText: '我知道了',
            });
        });
};

export default { init };
